import React from 'react';
import { DatePicker } from 'antd';
import { formConfig } from '../../../../config';
import FormItem from '../FormItem/FormItem';

const { fieldNames } = formConfig;

const SelectDocDateField = ({ form, required }) => {
  return (
    <FormItem label="Дата">
      {form.getFieldDecorator(fieldNames.docDate, {
        rules: [
          {
            required,
            message: 'Укажите дату',
          },
        ],
      })(
        <DatePicker
          allowClear={false}
          format="DD.MM.YYYY"
        />
      )}
    </FormItem>
  );
};

export default SelectDocDateField;
